import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/css';

const wrapper = (params) => css`
  position: absolute;
  top: 0;
  z-index: 1002;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  flex-direction: column;
  right: ${params?.alignLeft ? '0' : '-12px'};
  pointer-events: none;
`;

const optionTitle = (params) => css`
  padding: 10px 12px 20px 20px;
  font-family: inherit;
  font-size: 0.95em;
  text-decoration: underline;
  cursor: pointer;
  outline: none;
  display: flex;
  & svg {
    margin-left: 5px;
  }
  background-color: ${params?.backgroundColor};
  border-color: ${params?.borderColor};
  border-style: solid;
  border-width: ${params?.borderSize};
  color: ${params?.textColor};
  border-bottom: 0;
  z-index: 1002;
`;

const optionWrapper = (params) => css`
  margin-top: -${params?.borderSize.split(' ')[0]};
  background-color: ${params.backgroundColor};
  border-color: ${params.borderColor};
  border-width: ${params?.borderSize};
  border-style: solid;
  ${params?.alignLeft ? `
    padding: 20px 60px 20px 20px;
  ` : `
    padding: 20px 28px 20px 20px;
  `}
  display: flex;
  flex-direction: column;
  z-index: 1000;
  pointer-events: auto;
`;

const optionBtn = (params) => css`
  background: transparent;
  text-align: left;
  border: 0;
  outline: 0;
  color: ${params.textColor};
  margin: 4px 0;
  width: max-content;
  text-transform: capitalize;
  cursor: pointer;
  ${params?.isFilterActive && (
    `color: ${params.hoverTextColor};
     font-weight: bold;
    `
  )}
  &:not(.touch):hover {
    color: ${params?.hoverTextColor};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
    text-decoration: none;
    pointer-events: none;
  }
`;

const DropdownSingle = ({
  filter: {
    options,
    activeValue,
    key: filterKey,
    availableValues,
  },
  themeConfig,
  onChange,
  isMobile = false,
  onToggleMenu,
  title,
  icon,
}) => (
  <div className={wrapper({ ...themeConfig, ...(filterKey === 'date' ? { alignLeft: true } : {}) })}>
    <button type="button" className={optionTitle(themeConfig)} onClick={onToggleMenu}>
      {title}
      {icon}
    </button>
    <div className={optionWrapper({ ...themeConfig, ...(filterKey === 'date' ? { alignLeft: true } : {}) })}>
      {
        options.map((option) => (
          <button
            type="button"
            key={option.key}
            className={optionBtn({
              isMobile,
              isFilterActive: option.value.toString() === activeValue,
              ...themeConfig,
            })}
            onClick={onChange(filterKey, option.value)}
            disabled={availableValues ? !availableValues.includes(option.value) : false}
          >
            {option.name}
          </button>
        ))
      }
    </div>
  </div>
);

DropdownSingle.propTypes = {
  onChange: PropTypes.func,
  onToggleMenu: PropTypes.func,
  title: PropTypes.string,
  icon: PropTypes.object,
  filter: PropTypes.object,
  themeConfig: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default DropdownSingle;
